<div class="fantasy-panel rounded border overflow-hidden">
  <div class="row mx-0">
    <div
      class="col-12 px-0 bg-primary position-relative"
      [ngClass]="{ 'col-lg-7': horizontal, 'select-player-height': !horizontal }"
    >
      <div class="game-summary text-white">
        <div class="d-none d-lg-block">
          <div class="text-center line-height-18">
            <p class="mb-2 font-size-12">{{ 'pick.player.time.left' | translate }}</p>
            <fgbcl-countdown class="font-size-14 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
          </div>
          <div
            class="row team-vs-team d-flex justify-content-center align-items-center mx-0"
            [ngClass]="{ 'mt-5': horizontal, 'mt-3': !horizontal }"
          >
            <div class="team home col-4">
              <img
                *ngIf="game.HomeTeamLogo"
                class="d-flex ms-auto me-auto mt-3 mt-lg-0"
                src="{{ game.HomeTeamLogo | contentImage: '7' }}"
              />
            </div>
            <div class="versus col-4 text-center">
              <div class="svg svg-white vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
            </div>
            <div class="team away col-4">
              <img
                *ngIf="game.AwayTeamLogo"
                class="d-flex ms-auto me-auto mt-3 mt-lg-0"
                src="{{ game.AwayTeamLogo | contentImage: '7' }}"
              />
            </div>
          </div>
          <div class="line-height-18 font-size-12 text-center panel-date">
            <div class="date">{{ gameDate | uppercase }} - {{ gameTime }}</div>
          </div>
        </div>
        <div class="d-block d-lg-none">
          <div class="row mt-1">
            <div class="col-3 line-height-18 px-0 ms-3">
              <p class="mb-lg-0 mb-1 font-size-12">{{ 'pick.player.time.left' | translate }}</p>
              <fgbcl-countdown class="font-size-16 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
            </div>
            <div class="col-lg-12 col-8 d-flex flex-column px-0">
              <div class="row team-vs-team d-flex justify-content-center align-items-center mx-0">
                <div class="team home col-3 px-0">
                  <img *ngIf="game.HomeTeamLogo" class="d-flex mx-auto" src="{{ game.HomeTeamLogo | contentImage: '6' }}" />
                </div>
                <div class="col-6 d-flex flex-column px-0">
                  <div class="versus text-center mb-2">
                    <div class="svg svg-white vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
                  </div>
                  <div class="line-height-18 font-size-12 text-center">
                    <div class="dates">{{ gameDate | uppercase }} - {{ gameTime }}</div>
                  </div>
                </div>
                <div class="team away col-3 px-0">
                  <img *ngIf="game.AwayTeamLogo" class="d-flex mx-auto" src="{{ game.AwayTeamLogo | contentImage: '6' }}" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 py-2 px-lg-3 px-0" [ngClass]="{ 'col-lg-5': horizontal }">
      <div class="d-none d-lg-block">
        <div class="player-select text-center">
          <div class="player-image mx-auto rounded-4 border border-disabled overflow-hidden bg-muted">
            <img
              *ngIf="selectedPlayer && selectedPlayer.Image"
              src="{{ selectedPlayer.Image | contentImage: '6' }}"
              class="w-100 h-100 m-auto"
            />
          </div>

          <fgb-fantasy-player-select-confirm
            [isGamePending]="isGamePending"
            [game]="game"
            [buttonState]="buttonState"
            [selectedPlayer]="selectedPlayer"
            (button)="buttonClick()"
          >
          </fgb-fantasy-player-select-confirm>
        </div>
      </div>
      <div class="d-block d-lg-none">
        <div class="player-select text-center">
          <div class="d-flex px-3 mx-0 align-items-center">
            <div class="me-auto">
              <div class="player-image me-auto rounded border overflow-hidden bg-muted">
                <img
                  *ngIf="selectedPlayer && selectedPlayer.Image"
                  src="{{ selectedPlayer.Image | contentImage: '6' }}"
                  class="w-100 h-100 m-auto"
                />
              </div>
            </div>
            <div>
              <fgb-fantasy-player-select-confirm
                [isGamePending]="isGamePending"
                [game]="game"
                [buttonState]="buttonState"
                [selectedPlayer]="selectedPlayer"
                (button)="buttonClick()"
              >
              </fgb-fantasy-player-select-confirm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
